/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {CollectionFactory, Reducer} from '@modifi/redux'
import {ExistingBankAccountView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {createSelector} from 'reselect'

const apiClient = getAuthenticatedThemisClient()

const {selectors, actions, reducer} = CollectionFactory<
  Record<string, any>,
  ExistingBankAccountView,
  never
>({
  actionNamePrefix: 'data/seller-bank-accounts/collection',
  reducerPath: ['data', 'sellerBankAccounts', 'collection'],
  fetchRequest: () =>
    apiClient.SellerBankAccounts.fetch().then(res => res.data()?.sellerBankAccounts || []),
  entityPrimaryKeySelector: entity => entity.externalId!,
})

export default reducer as Reducer

export const selectSellerBankAccounts = (state: Record<string, any>): ExistingBankAccountView[] =>
  selectors.selectByKeyWindow(state, {}) as ExistingBankAccountView[]

export const selectSellerBankAccountsAreLoading = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, {})

export const selectSellerBankAccountsWhereLoaded = (state: Record<string, any>): boolean =>
  selectors.selectFetchCountByKeyWindow(state, {}) > 0

export const selectSellerBankAccountByExternalId = (
  state: Record<string, any>,
  externalCompanyId: string
): ExistingBankAccountView | null =>
  selectors.selectById(state, externalCompanyId) as ExistingBankAccountView | null

export const selectSellerBankAccountIntermediaryBankName = createSelector(
  selectSellerBankAccountByExternalId,
  bankAccount => bankAccount?.intermediaryBank?.bankName || ''
)

// @ts-expect-error sending empty since no keywindow id
export const aFetchSellerBankAccounts = (): any => actions!.fetch({})

export const aAppendSellerBankAccountToCompanyInLocalStore = (
  entity: ExistingBankAccountView
): any => actions!.appendEntity?.({}, {ident: entity.externalId!, entity})

export const aUpdateLocalSellerBankAccount = (
  entity: ExistingBankAccountView & {
    externalId: NonNullable<ExistingBankAccountView['externalId']>
  },
  merge = true
): any => actions!.update(entity, merge)
